// The follow-up route of a Call Logs row, used by the outcome fallback for a backend that has no
// outcome endpoint yet (callOutcome.api.js):
//   POST /api/v1/practices/{p}/calls/{id}/follow-up/
//   { action: 'attempted' | 'responded' | 'ignored', via: 'call' | 'whatsapp' | 'sms' | 'manual', note }
export const callFollowUpUrl = (practiceId, callId) => `/api/v1/practices/${practiceId}/calls/${encodeURIComponent(callId)}/follow-up/`;
